import React from "react";
import { motion } from "framer-motion";
import { SITE } from "@/constants/testIds";

const STEPS = [
  { y: "2020", t: "Straight Arrow Studios", d: "Founded in Bangalore. A small studio with a projection wall, a few cameras, and one rule: make work that earns its runtime." },
  { y: "2021 – 2022", t: "Range, Then Reputation", d: "From corporate films to consumer launches to recruitment campaigns. The breadth that shaped the philosophy." },
  { y: "2023", t: "1600+ Projects", d: "300+ brands across India. 700+ creative partners. The infrastructure of a production house with the temperament of a studio." },
  { y: "2024 – 2025", t: "A Realisation", d: "The work that mattered most always began with a problem — not a brief, not a shotlist, not a deck. Camera came last." },
  { y: "2026", t: "RELATABLE", d: "Same team. Same craft. A clearer name for what we\u2019ve always done. We solve problems before we pick up a camera." },];

export default function Legacy() {
  return (
    <section data-testid={SITE.legacySection} className="bg-ink text-bone py-20 md:py-24 lg:py-28 relative overflow-hidden">
      <div className="relative px-6 md:px-12 lg:px-24">
        <div className="max-w-4xl">
          <p className="eyebrow text-fog mb-5">◐ Legacy — Before We Were Relatable</p>
          <h2 className="font-display text-5xl md:text-7xl lg:text-8xl tracking-tighter font-medium leading-[0.92]">
            Six years.<br/>One studio.<br/>A new name.
          </h2>
          <p className="mt-8 max-w-2xl text-fog text-base md:text-lg leading-relaxed">
            We didn&rsquo;t pivot. We didn&rsquo;t rebrand for the deck. We just spent six years learning the same lesson on every project — and gave it a name we couldn&rsquo;t mistake.
          </p>
        </div>

        <div className="mt-20 md:mt-28 grid grid-cols-12 gap-y-10">
          {STEPS.map((s, i) => (
            <motion.div
              key={s.y}
              initial={{ opacity: 0, y: 24 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ delay: i * 0.08, duration: 0.6 }}
              className="col-span-12 grid grid-cols-12 gap-x-6 md:gap-x-8 items-start border-t border-line pt-8"
            >
              <div className="col-span-12 md:col-span-2 flex items-start gap-3">
                <span className="block w-3 h-3 bg-relatable mt-2" />
                <span className="font-display text-xl md:text-2xl tracking-tight text-bone">{s.y}</span>
              </div>
              <h3 className="col-span-12 md:col-span-4 font-display text-2xl md:text-3xl lg:text-4xl tracking-tight font-medium text-bone">
                {s.t}
              </h3>
              <p className="col-span-12 md:col-span-6 text-fog text-base md:text-lg leading-relaxed">{s.d}</p>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
}
